import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import {
  Box,
  Paper,
  TextField,
  Button,
  FormControl,
  FormHelperText,
  Grid2
} from '@mui/material';

import React, { useState, useEffect, useMemo } from 'react';
import { useFormik } from "formik";
import * as yup from "yup";

import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { useDispatch, useSelector } from "react-redux";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { postReply } from "Slices/thunks";
import { toast } from "react-toastify";

const toolbar = [
  'bold', 
  'italic', 
  'link', 
  'bulletedList', 
  'numberedList'
]

const styles = (theme) => ({
  '& .ck-editor__editable': {
    padding: "0 20px",
    height: "250px !important"
  }
})

const initialValues = {
  Content: ""
}

const ReplyDialog = ({ open, setOpen, post }) => {
  const dispatch = useDispatch();

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.DiscussionHub || {}
  }));

  const Schema = useMemo(() => {
    return yup.object({
      Content: yup.string().required(Translation?.ReplyMessageRequired || "Reply is required field."),
    });
  }, [Translation]) 

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
    submitCount,
    resetForm,
    setValues,
    setFieldTouched,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: async (data) => {
      console.log('data: ', data);
      try {
        await dispatch(postReply({PostID: post.ID, Content: data.Content})).unwrap();
        setOpen(false);
        toast.success(Translation?.PostCreatedSuccessfully);

      } catch (error) {
        toast.error(Translation?.SomethingWentWrong);
        
      }
    },
    validationSchema: Schema,
  });


  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      resetForm({});
      setValues(initialValues);
    }

  }, [open])


  return (
    <Dialog fullWidth maxWidth={"lg"} open={open} onClose={handleClose}>
      <DialogTitle>
        {post?.Title}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <DialogContent>
      
          <Grid2 spacing={2} container sx={styles}>
            <Grid2 size={6}>
              
              {/* Editor Toolbar */}
              <FormControl variant="standard" fullWidth>
                <CKEditor
                  editor={ClassicEditor}
                  data={values.Content}
                  config={{toolbar}}
                  onBlur={() => setFieldTouched("Content", true)}
                  onChange={(event, editor) => {
                    setFieldValue("Content", editor.getData())
                  }}
                />
                {touched.Content && errors.Content && (
                  <FormHelperText color="error.main" sx={(theme) => ({color: theme.palette.error.main})} >{errors.Content}</FormHelperText>
                )}
              </FormControl>
            </Grid2>
            <Grid2 size={6}>
              <Box dangerouslySetInnerHTML={{__html: values.Content}} mt={1}></Box>
            </Grid2>
          </Grid2>

        </DialogContent>
        <DialogActions align="center" mt={2}>
          <Button type="submit" variant="contained">
            {Translation?.Reply}
          </Button>
          <Button
            onClick={() => handleClose()}
            variant="outlined"
            color="secondary"
          >
            {Translation?.Cancel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ReplyDialog;